module.exports = __webpack_public_path__ + "static/img/shutterstockWiseBrain.3b7a591.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/shutterstockWiseBrain.png
// module id = ajlG
// module chunks = 1